export class CorrespondreDossierEtCoreBanking
{
    requestId: String;
    numeroDossierPret: String;
    numDossier: String;
    dateReelMiseEnPlace: String;
}